/**
 * Helpers de formatação pra Story 11.7 (UI métricas comparativas).
 *
 * Funções pure (sem React) testáveis isoladamente.
 */

/**
 * Formata um rate (0..1) como porcentagem.
 *
 *   formatRate(0.234) → "23.4%"
 *   formatRate(null)  → "—"
 *   formatRate(0)     → "0.0%"
 *   formatRate(1)     → "100.0%"
 */
export function formatRate(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${(value * 100).toFixed(1)}%`;
}

/**
 * Formata duração em ms para string legível.
 *
 *   formatDuration(1500)   → "1.5s"
 *   formatDuration(95000)  → "1m 35s"
 *   formatDuration(null)   → "—"
 *   formatDuration(450)    → "0.5s"
 */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || Number.isNaN(ms) || ms < 0) return '—';
  if (ms < 1000) return `${(ms / 1000).toFixed(1)}s`;
  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds < 60) return `${(ms / 1000).toFixed(1)}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
}

/**
 * Formata uma Date como string `YYYY-MM-DD` (compatível com `<input type="date">`).
 *
 *   toDateInputValue(new Date('2026-05-20T12:00:00Z')) → "2026-05-20"
 */
export function toDateInputValue(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Parse de string `YYYY-MM-DD` para Date no início do dia local.
 * Retorna null pra inputs inválidos.
 */
export function fromDateInputValue(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parts = value.split('-');
  const yyyy = Number(parts[0]);
  const mm = Number(parts[1]);
  const dd = Number(parts[2]);
  const d = new Date(yyyy, mm - 1, dd, 0, 0, 0, 0);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}
